import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Fab from '@material-ui/core/Fab'
import Hidden from '@material-ui/core/Hidden'
import Button from '@material-ui/core/Button'
import Checkbox from 'ui/components/checkbox'
import IconButton from '@material-ui/core/IconButton'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconAdd } from 'assets/icons/add.svg'
import { ReactComponent as IconDelete } from 'assets/icons/delete.svg'
import { ReactComponent as IconDownload } from 'assets/icons/download.svg'
import useStyles from './actionsStyles'
import useTranslation from 'hooks/useTranslations'

const Actions = ({
  status,
  onBulkSelect,
  canDelete,
  canAdd,
  onAddVendor,
  onRemoveVendors,
  hideItemActions,
  canDownload,
  onCSVExport,
}) => {
  const t = useTranslation()
  const classes = useStyles()
  const handleRemoveVendors = useCallback(() => {
    onRemoveVendors()
  }, [onRemoveVendors])

  return (
    <>
      <Hidden smUp>
        <Box
          className={classes.actionsMobile}
          display="flex"
          alignItems="center"
        >
          {!hideItemActions ? (
            <IconButton
              className={classes.actionsButton}
              aria-label="delete"
              color="primary"
              disabled={canDelete}
              onClick={handleRemoveVendors}
            >
              <SvgIcon component={IconDelete} />
            </IconButton>
          ) : null}
          {canAdd ? (
            <Fab
              className={classes.actionsFab}
              color="primary"
              aria-label="add"
              onClick={onAddVendor}
            >
              <SvgIcon component={IconAdd} />
            </Fab>
          ) : null}
        </Box>
      </Hidden>
      <Hidden xsDown>
        <Box
          className={classes.actionsDesktop}
          mb={2}
          display="flex"
          alignItems="center"
          justifyContent={hideItemActions ? 'flex-end' : 'space-between'}
        >
          {!hideItemActions ? (
            <Box display="flex" alignItems="center">
              <Checkbox
                className={classes.actionsCheckbox}
                indeterminate={status === 'partial'}
                checked={status === 'full'}
                onClick={onBulkSelect}
              />
              <IconButton
                className={classes.actionsButton}
                aria-label="delete"
                color="primary"
                disabled={canDelete}
                onClick={handleRemoveVendors}
              >
                <SvgIcon component={IconDelete} />
              </IconButton>
            </Box>
          ) : null}

          <Box display="flex" alignItems="center">
            {onCSVExport ? (
              <Button
                className={classes.actionsButton}
                variant="outlined"
                color="primary"
                startIcon={<SvgIcon component={IconDownload} />}
                onClick={onCSVExport}
                disabled={!canDownload}
              >
                {t('search:download-detail')}
              </Button>
            ) : null}
            {canAdd ? (
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<SvgIcon component={IconAdd} />}
                onClick={onAddVendor}
              >
                {t('vendor:add')}
              </Button>
            ) : null}
          </Box>
        </Box>
      </Hidden>
    </>
  )
}

Actions.propTypes = {
  status: PropTypes.oneOf(['partial', 'full', 'none']),
  onBulkSelect: PropTypes.func,
  canDelete: PropTypes.bool,
  onAddVendor: PropTypes.func,
  onRemoveVendors: PropTypes.func,
  hideItemActions: PropTypes.bool,
  onCSVExport: PropTypes.func,
}

export default Actions
